// src/components/modal/EditReserv.jsx
import React, {useEffect, useState} from 'react';
import {format} from 'date-fns';
import {Calendar, Check, Home, Phone, User, X} from 'lucide-react';
import confetti from 'canvas-confetti';
// import sound from "../../../sounds/reserv_save.mp3";
import Cookies from 'js-cookie';

const EditReserv = ({isOpen, onClose, item, onSave}) => {

    const isEdit = !!item?.id;
    const [managerId] = Cookies.get('manager_id') || '1';

    const [form, setForm] = useState({
        id: item?.id || null,
        Client_Name: item?.Client_Name || '',
        phone: item?.phone || item?.Client_Phone || '',
        manager_id: managerId,
        rooms_id: item?.rooms_id || item?.room || '1',
        Date_In: item?.checkIn || format(new Date(), 'yyyy-MM-dd'),
        Date_Out: item?.checkOut || format(new Date(), 'yyyy-MM-dd'),
    });

    const [error, setError] = useState('');

    const PUBLIC_URL = '/wp-content/include-me/hotel_man_web/';


    useEffect(() => {
        if (isOpen && item) {
            setForm({
                id: item.id || null,
                Client_Name: item.Client_Name || item.name || '',
                phone: item.phone || item.Client_Phone || '',
                manager_id: String(managerId),
                rooms_id: String(item.rooms_id || item.room || '1'),
                Date_In: item.checkIn || item.Date_In || format(new Date(), 'yyyy-MM-dd'),
                Date_Out: item.checkOut || item.Date_Out || format(new Date(), 'yyyy-MM-dd'),
            });
            setError('');
        }
    }, [isOpen, item]);

    const handleSave = async () => {
        if (!form.Client_Name.trim()) {
            setError('Введите ФИО гостя');
            return;
        }
        if (form.Date_In >= form.Date_Out) {
            setError('Дата выезда должна быть позже заезда');
            return;
        }

        const success = await onSave(form);
        if (success) {
            // КОНФЕТТИ ПРИ УСПЕШНОМ СОХРАНЕНИИ!
            confetti({
                particleCount: 100,
                spread: 70,
                origin: {y: 0.6}
            });

            const soundPath = PUBLIC_URL + 'static/media/reserv_save.afcb8e9dc1976a0858cd.mp3';
            const audio = new Audio(soundPath);
            audio.volume = 0.7;
            audio.play().catch(() => {
            });


            onClose();
        } else {
            setError('Ошибка сохранения. Попробуйте ещё раз.');
        }
    };

    if (!isOpen) return null;

    return (
        <>
            {/* Затемнение */}
            <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50" onClick={onClose}/>

            {/* Модалка снизу с анимацией */}
            <div className="fixed inset-x-4 bottom-24 z-50 animate-ios-bottom-sheet">
                <div className="bg-white rounded-3xl shadow-2xl border border-gray-200 overflow-hidden">
                    {/* Заголовок */}
                    <div className="flex items-center justify-between p-2 ml-6 border-b border-gray-100">
                        <h2 className="text-2xl font-bold text-gray-900">
                            {isEdit ? 'Редактирование ' : 'Добавление'}
                        </h2>
                        <button
                            onClick={onClose}
                            className="p-2 hover:bg-gray-100 rounded-xl transition"
                        >
                            <X size={28} className="text-gray-500"/>
                        </button>
                    </div>

                    {/* Форма */}
                    <div className="p-6 space-y-5">
                        {/* ФИО */}
                        <div>
                            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                                <User size={18}/> ФИО гостя
                            </label>
                            <input
                                type="text"
                                value={form.Client_Name}
                                onChange={e => setForm({...form, Client_Name: e.target.value})}
                                placeholder="Иванов Иван Иванович"
                                className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-blue-500 focus:outline-none transition"
                            />
                        </div>

                        {/* Телефон */}
                        <div>
                            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                                <Phone size={18}/> Телефон
                            </label>
                            <input
                                type="tel"
                                value={form.phone}
                                onChange={e => setForm({...form, phone: e.target.value})}
                                placeholder="+7 (999) 123-45-67"
                                className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-blue-500 focus:outline-none transition"
                            />
                        </div>

                        {/* Комната */}
                        <div>
                            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                                <Home size={18}/> Номер комнаты
                            </label>
                            <select
                                value={form.rooms_id}
                                onChange={e => setForm({...form, rooms_id: e.target.value})}
                                className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-blue-500 focus:outline-none transition"
                            >
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => (
                                    <option key={n} value={n}>Номер {n}</option>
                                ))}
                            </select>
                        </div>

                        {/* Даты */}
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                                    <Calendar size={18}/> Заезд
                                </label>
                                <input
                                    type="date"
                                    value={form.Date_In}
                                    onChange={e => setForm({...form, Date_In: e.target.value})}
                                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-blue-500 focus:outline-none transition"
                                />
                            </div>
                            <div>
                                <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                                    Выезд
                                </label>
                                <input
                                    type="date"
                                    value={form.Date_Out}
                                    onChange={e => setForm({...form, Date_Out: e.target.value})}
                                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-red-500 focus:outline-none transition"
                                />
                            </div>
                        </div>

                        {/* Ошибка */}
                        {error && (
                            <div className="bg-red-50 text-red-600 px-4 py-3 rounded-xl text-sm font-medium">
                                {error}
                            </div>
                        )}
                    </div>

                    {/* Кнопки */}
                    <div className="flex gap-3 p-6 border-t border-gray-100">
                        <button
                            onClick={onClose}
                            className="flex-1 py-3 rounded-2xl border border-gray-300 font-medium text-gray-700 hover:bg-gray-50 transition"
                        >
                            Отмена
                        </button>
                        <button
                            onClick={handleSave}
                            className="flex-1 py-3 rounded-2xl bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold hover:from-blue-700 hover:to-indigo-700 transition shadow-lg flex items-center justify-center gap-2"
                        >
                            <Check size={20}/>Сохранить
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditReserv;
